/*
 * Application Insights JavaScript SDK - Core, 3.0.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
"use strict";
export var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map